function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 18l8-9.333L1 0",
  stroke: "#160B2C",
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgRightArrowBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTAgMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+UGF0aCAzIENvcHkgMzwvdGl0bGU+CiAgICA8ZyBpZD0iV2Vic2l0ZS1kZXNrdG9wIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJQcm9ncmFtcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY2NS4wMDAwMDAsIC02OTIuMDAwMDAwKSIgc3Ryb2tlPSIjMTYwQjJDIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTE1LUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM5Ni4wMDAwMDAsIDY1NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aC0zLUNvcHktMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjc0LjAwMDAwMCwgNDcuMDAwMDAwKSByb3RhdGUoLTkwLjAwMDAwMCkgdHJhbnNsYXRlKC0yNzQuMDAwMDAwLCAtNDcuMDAwMDAwKSAiIHBvaW50cz0iMjY1IDQzIDI3NC4zMzMzMzMgNTEgMjgzIDQzIj48L3BvbHlsaW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgRightArrowBubble as ReactComponent };